import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, ShieldCheckIcon, ZapIcon, DownloadIcon } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
const benefits = ['Comprende mejor tus emociones', 'Reduce la ansiedad mental', 'Encuentra mayor claridad interior', 'Herramientas simples y prácticas', 'Empieza tu proceso de sanación'];
export function HeroSection() {
  return <section className="relative min-h-screen flex flex-col overflow-hidden bg-[#F7F3E9]" data-id="element-112">
      {/* Premium Top Banner */}
      <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      ease: 'easeOut'
    }} className="relative z-20 w-full bg-gradient-to-r from-[#F4A261] via-[#FFD166] to-[#F4A261] py-3 px-4 text-center shadow-md" data-id="element-113">
        <div className="flex items-center justify-center gap-2" data-id="element-114">
          <span className="text-base" data-id="element-115">✨</span>
          <span className="text-xs sm:text-sm font-bold tracking-[0.2em] text-[#2F3A3D] uppercase" data-id="element-116">
            Guía De Bienestar Emocional — Oferta Especial
          </span>
          <span className="text-base" data-id="element-117">✨</span>
        </div>
      </motion.div>

      {/* Hero Content Area */}
      <div className="relative flex-1 flex items-center justify-center px-4 py-16 lg:py-28" data-id="element-118">
        {/* Background Image */}
        <div className="absolute inset-0 pointer-events-none" data-id="element-119">
          <img src="https://cdn.magicpatterns.com/uploads/5oPgSK5PxqNkX1gGsUK12L/13_mar_2026,_11_51_55_p.m..png" alt="" className="w-full h-full object-cover" data-id="element-120" />
          {/* Overlay for legibility */}
          <div className="absolute inset-0 bg-[#F7F3E9]/70" data-id="element-121"></div>
        </div>
        {/* Background Effects */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-122">
          <div className="absolute -top-[20%] -right-[10%] w-[70%] h-[70%] bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-[#FFD166]/30 via-[#FFD166]/10 to-transparent blur-3xl opacity-80 rounded-full mix-blend-overlay" data-id="element-123"></div>
          <div className="absolute -bottom-[20%] -left-[10%] w-[60%] h-[60%] bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-[#6EC1E4]/20 via-[#6EC1E4]/5 to-transparent blur-3xl opacity-60 rounded-full" data-id="element-124"></div>
          <div className="absolute top-[30%] left-[20%] w-[40%] h-[40%] bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-[#7FB77E]/15 via-transparent to-transparent blur-3xl opacity-50 rounded-full" data-id="element-125"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto w-full flex flex-col lg:flex-row items-center gap-16 lg:gap-12" data-id="element-126">
          {/* LEFT COLUMN: Content */}
          <div className="flex-1 w-full max-w-2xl lg:max-w-xl xl:max-w-2xl flex flex-col items-center text-center lg:items-start lg:text-left" data-id="element-127">
            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.1,
            ease: 'easeOut'
          }} className="font-serif text-4xl sm:text-5xl lg:text-6xl font-bold text-[#2F3A3D] leading-[1.1] mb-6 tracking-tight" data-id="element-128">
              RECUPERA
              <br data-id="element-129" />
              <span className="text-[#F4A261]" data-id="element-130">TU BIENESTAR EMOCIONAL</span>
              <br data-id="element-131" />
              PASO A PASO
            </motion.h1>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.2,
            ease: 'easeOut'
          }} className="text-lg sm:text-xl text-[#5F6368] mb-8 leading-relaxed max-w-xl" data-id="element-132">
              Una guía práctica para comprender tus emociones, calmar tu mente y
              comenzar tu proceso de sanación interior.
            </motion.p>

            <motion.ul initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.3,
            ease: 'easeOut'
          }} className="space-y-3 mb-10 text-left w-full max-w-md" data-id="element-133">
              {benefits.map((benefit, index) => <li key={index} className="flex items-start gap-3" data-id="element-134">
                  <CheckCircle2Icon className="w-6 h-6 text-[#7FB77E] flex-shrink-0 mt-0.5" data-id="element-135" />
                  <span className="text-[#2F3A3D] font-medium" data-id="element-136">{benefit}</span>
                </li>)}
            </motion.ul>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.4,
            ease: 'easeOut'
          }} className="w-full max-w-md flex flex-col items-center lg:items-start" data-id="element-137">
              <div className="bg-white/90 backdrop-blur-sm rounded-2xl px-6 py-4 shadow-lg border border-[#FFD166]/30 mb-5" data-id="element-138">
                <div className="flex items-baseline gap-2 justify-center" data-id="element-139">
                  <span className="text-3xl sm:text-4xl font-bold text-[#2F3A3D] leading-none" data-id="element-140">
                    Solo
                  </span>
                  <span className="text-5xl sm:text-6xl lg:text-7xl font-extrabold leading-none bg-gradient-to-r from-[#F4A261] via-[#FFD166] to-[#F4A261] bg-clip-text text-transparent drop-shadow-sm" data-id="element-141">
                    $6.39
                  </span>
                  <span className="text-lg text-[#5F6368] line-through ml-2 self-center" data-id="element-142">
                    Antes $49
                  </span>
                </div>
              </div>

              <CTAButton href="#precio" className="w-full py-5 text-lg" data-id="element-143">
                QUIERO EMPEZAR MI CAMINO
              </CTAButton>

              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 sm:gap-6 mt-6 text-xs sm:text-sm font-medium text-[#5F6368]" data-id="element-144">
                <div className="flex items-center gap-1.5" data-id="element-145">
                  <ShieldCheckIcon className="w-4 h-4 text-[#7FB77E]" data-id="element-146" />
                  <span data-id="element-147">Pago seguro</span>
                </div>
                <div className="flex items-center gap-1.5" data-id="element-148">
                  <ZapIcon className="w-4 h-4 text-[#FFD166]" data-id="element-149" />
                  <span data-id="element-150">Acceso inmediato</span>
                </div>
                <div className="flex items-center gap-1.5" data-id="element-151">
                  <DownloadIcon className="w-4 h-4 text-[#6EC1E4]" data-id="element-152" />
                  <span data-id="element-153">Descarga digital</span>
                </div>
              </div>
            </motion.div>
          </div>

          {/* RIGHT COLUMN: Product Mockups */}
          <motion.div initial={{
          opacity: 0,
          x: 40,
          scale: 0.95
        }} animate={{
          opacity: 1,
          x: 0,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="flex-1 w-full max-w-2xl relative flex items-center justify-center" data-id="element-154">
            {/* Soft glow behind mockups */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-[#FFD166]/20 via-transparent to-transparent blur-2xl -z-10" data-id="element-155"></div>

            <motion.div animate={{
            y: [-5, 5, -5]
          }} transition={{
            duration: 6,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="relative w-full aspect-square max-w-[600px] flex items-center justify-center" data-id="element-156">
              {/* Laptop Mockup (Back) */}
              <div className="absolute top-[5%] right-[5%] w-[75%] aspect-[16/10] bg-[#3a4548] rounded-t-xl rounded-b-sm shadow-2xl border-[6px] border-[#3a4548] transform rotate-2 hover:rotate-0 transition-transform duration-500 z-10" data-id="element-157">
                <div className="w-full h-full bg-slate-900 overflow-hidden relative" data-id="element-158">
                  <img src="https://cdn.magicpatterns.com/uploads/s2wh1etg2tDd7vNYD6w5qp/ChatGPT_Image_9_mar_2026,_11_52_04_a.m..png" alt="Camino a la Luz Ebook on Laptop" className="w-full h-full object-cover opacity-90" data-id="element-159" />
                  <div className="absolute inset-0 bg-gradient-to-tr from-black/20 to-transparent pointer-events-none" data-id="element-160"></div>
                </div>
                {/* Laptop Base */}
                <div className="absolute -bottom-3 -left-4 -right-4 h-3 bg-slate-300 rounded-b-xl shadow-xl border-t border-slate-400" data-id="element-161"></div>
              </div>

              {/* Tablet Mockup (Middle Left) */}
              <div className="absolute bottom-[15%] left-[5%] w-[45%] aspect-[3/4] bg-[#1a1a1a] rounded-2xl shadow-2xl border-[8px] border-[#1a1a1a] transform -rotate-6 hover:-rotate-2 transition-transform duration-500 z-20" data-id="element-162">
                <div className="w-full h-full bg-slate-900 rounded-lg overflow-hidden relative" data-id="element-163">
                  <img src="https://cdn.magicpatterns.com/uploads/s2wh1etg2tDd7vNYD6w5qp/ChatGPT_Image_9_mar_2026,_11_52_04_a.m..png" alt="Camino a la Luz Ebook on Tablet" className="w-full h-full object-cover" data-id="element-164" />
                  <div className="absolute inset-0 bg-gradient-to-br from-white/20 via-transparent to-transparent pointer-events-none" data-id="element-165"></div>
                </div>
              </div>

              {/* Smartphone Mockup (Front Right) */}
              <div className="absolute bottom-[5%] right-[20%] w-[28%] aspect-[9/16] bg-[#3a4548] rounded-[2rem] shadow-2xl border-[6px] border-[#3a4548] transform rotate-6 hover:rotate-0 transition-transform duration-500 z-30" data-id="element-166">
                <div className="w-full h-full bg-[#1a1a1a] rounded-[1.5rem] overflow-hidden relative" data-id="element-167">
                  <img src="https://cdn.magicpatterns.com/uploads/7p66pu5w9125Shg4XbPNch/ChatGPT_Image_14_mar_2026,_12_04_34_a.m..png" alt="Camino a la Luz Ebook on Smartphone" className="w-full h-full object-cover" data-id="element-168" />
                  <div className="absolute top-2 left-1/2 -translate-x-1/2 w-1/3 h-4 bg-black rounded-full z-10" data-id="element-169"></div>
                  <div className="absolute inset-0 bg-gradient-to-tr from-white/10 via-transparent to-transparent pointer-events-none" data-id="element-170"></div>
                </div>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}